import { FC } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'types';

import { t } from 'utils';
import styles from './InfoBlock.module.css';
import texts from '../../../texts';

type Props = {
  company?: boolean;
  numberOfMachines?: number;
};

export const InfoBlock: FC<Props> = ({ company, numberOfMachines = 1 }) => {
  const { registerData } = useSelector((state: RootState) => state.auth);
  return (
    <div>
      <div className={styles.item}>
        <p className={styles.label}>{t(texts.infoBlock.yourName)}</p>
        <p className={styles.itemText}>{registerData.fullName}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>{t(texts.infoBlock.yourPosition)}</p>
        <p className={styles.itemText}>{registerData.yourPosition}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>{t(texts.infoBlock.email)}</p>
        <p className={styles.itemText}>{registerData.email}</p>
      </div>
      {registerData.phoneNumber && (
        <div className={styles.item}>
          <p className={styles.label}>{t(texts.infoBlock.phone)}</p>
          <p className={styles.itemText}>{registerData.phoneNumber}</p>
        </div>
      )}
      <div className={styles.item}>
        <p className={styles.label}>
          {company ? t(texts.infoBlock.companyName) : t(texts.infoBlock.clinicName)}
        </p>
        <p className={styles.itemText}>{registerData.clinicName}</p>
      </div>
      <div className={styles.item}>
        <p className={styles.label}>
          {t(texts.infoBlock.numberOf)}{' '}
          {company ? t(texts.infoBlock.clinics) : t(texts.infoBlock.computers)}
        </p>
        <p className={styles.itemText}>{numberOfMachines}</p>
      </div>
    </div>
  );
};
